import { CreateExperimentBlockedReason } from '../api/models'

export interface CreateExperimentBlockedMessage {
  message: string
  showRequestAccess: boolean
}

export const CREATE_EXPERIMENT_BLOCKED_MESSAGES: Record<CreateExperimentBlockedReason, CreateExperimentBlockedMessage> =
  {
    [CreateExperimentBlockedReason.MISSING_SHAREPOINT_ACCOUNT]: {
      message:
        'Your account is not registered in SharePoint yet. Please contact your administrator to get registered before creating experiments.',
      showRequestAccess: false,
    },
    [CreateExperimentBlockedReason.INSUFFICIENT_PERMISSION]: {
      message: "You don't have permission to create experiments.",
      showRequestAccess: true,
    },
  }

// Fallback used when the user is blocked but no structured reason is available
// (legacy VIEWER block when the backend has not yet sent create_experiment_blocked_reason).
export const DEFAULT_CREATE_EXPERIMENT_BLOCKED_MESSAGE: CreateExperimentBlockedMessage = {
  message: "You don't have permission to create experiments.",
  showRequestAccess: true,
}

export const getCreateExperimentBlockedMessage = (
  reason: CreateExperimentBlockedReason | null,
): CreateExperimentBlockedMessage =>
  reason ? (CREATE_EXPERIMENT_BLOCKED_MESSAGES[reason] ?? DEFAULT_CREATE_EXPERIMENT_BLOCKED_MESSAGE) : DEFAULT_CREATE_EXPERIMENT_BLOCKED_MESSAGE
